import { useSelector } from "react-redux";
import { skipToken } from "@reduxjs/toolkit/query";
import { CorpSessionInfo, SessionInfo } from "redmond";
import { useGetProjectsAndCategoriesQuery } from "@capone/common";
import {
  AVAILABLE,
  getExperimentVariant,
  PROJECTS_AND_CATEGORIES_FLOW,
  useExperiments,
} from "../context/experiments";
import { getSelectedAccountReferenceId } from "../modules/rewards/reducer/selectors";

const isProfileEnrolled = (
  sessionInfo: SessionInfo | CorpSessionInfo | undefined
): boolean =>
  sessionInfo != null &&
  "corporateInfo" in sessionInfo &&
  sessionInfo.corporateInfo.isProfileEnrolledInExpenseManagement === true;

// Prefetches Projects & Categories for the active account once the user is
// known to be EM-enrolled and the rollout flag is on. Keyed on the selected
// account's reference id, so RTK Query's cache naturally refetches when the
// account switches and keeps prior accounts' lookups in memory for the session.
export const useProjectsAndCategoriesPrefetch = (
  sessionInfo: SessionInfo | CorpSessionInfo | undefined
) => {
  const expState = useExperiments();
  const isFlowEnabled =
    getExperimentVariant(expState.experiments, PROJECTS_AND_CATEGORIES_FLOW) ===
    AVAILABLE;

  const selectedAccountReferenceId = useSelector(
    getSelectedAccountReferenceId
  );

  const shouldPrefetch = isFlowEnabled && isProfileEnrolled(sessionInfo);

  return useGetProjectsAndCategoriesQuery(
    shouldPrefetch && selectedAccountReferenceId != null
      ? { accountReferenceId: selectedAccountReferenceId }
      : skipToken
  );
};
